import React from 'react'
import {
  FormDashboardLabel as Label,
  FormDashboardInputNumber as InputNumber,
  // Radio,
  FormDashboardInput,
} from '../../../components'
import { SurveyInput } from './survey-input'
import { SatisfactionInput } from './satisfaction-input'
import { NpsInput } from './nps-input'

const Beneficiaries = ({form, updateForm}) => {
  return (
    <div>
      <div className="flex flex-wrap items-center mb-5 lg:mb-8">
        <p className="w-full lg:w-auto text-lg font-bold mb-2 lg:mb-0">Beneficiaries</p>
        {/* <div className="hidden lg:block mx-5">|</div>
        <div className="flex items-center">
          <p className="text-sm font-bold mr-4">Visibility:</p>
          <Radio
            name="beneficiaries_visibility"
            id="beneficiaries_visibility1"
            label="Public"
            value="public"
            className="mr-4"
            form={form}
            onChange={updateForm}
          />
          <Radio
            name="beneficiaries_visibility"
            id="beneficiaries_visibility2"
            label="Only me"
            value="onlyme"
            form={form}
            onChange={updateForm}
          />
        </div> */}
      </div>

      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-1/2 px-4">
          <div className="mb-8 lg:mb-0 lg:pr-10">
            <Label>Beneficiaries by gender</Label>
            <div className="flex justify-between items-center mb-4 lg:mb-2 pt-1">
              <p className="w-1/2 text-sm text-gray-444">Men</p>
              <InputNumber className="w-1/2"/>
            </div>
            <div className="flex justify-between items-center">
              <p className="w-1/2 text-sm text-gray-444">Women</p>
              <InputNumber className="w-1/2"/>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/2 px-4">
          <div className="mb-8 lg:mb-0 lg:pr-10">
            <Label>Beneficiaries by gender difable</Label>
            <div className="flex justify-between items-center mb-4 lg:mb-2 pt-1">
              <p className="w-1/2 text-sm text-gray-444">Men</p>
              <InputNumber className="w-1/2"/>
            </div>
            <div className="flex justify-between items-center">
              <p className="w-1/2 text-sm text-gray-444">Women</p>
              <InputNumber className="w-1/2"/>
            </div>
          </div>
        </div>
        {/* <div className="w-full lg:w-1/2 px-4">
          <div className="mb-2 lg:mb-0 lg:pr-10">
            <Label>Beneficiaries by type</Label>
            <div className="flex justify-between items-center mb-4 lg:mb-2 pt-1">
              <p className="w-1/2 text-sm text-gray-444">Direct</p>
              <InputNumber className="w-1/2"/>
            </div>
            <div className="flex justify-between items-center">
              <p className="w-1/2 text-sm text-gray-444">Indirect</p>
              <InputNumber className="w-1/2"/>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  )
}

const Impact = ({form, updateForm}) => {
  return (
    <div>
      <div className="flex flex-wrap items-center mb-5 lg:mb-8">
        <p className="w-full lg:w-auto text-lg font-bold mb-2 lg:mb-0">Impact</p>
        {/* <div className="hidden lg:block mx-5">|</div>
        <div className="flex items-center">
          <p className="text-sm font-bold mr-4">Visibility:</p>
          <Radio
            name="impact_visibility"
            id="impact_visibility1"
            label="Public"
            value="public"
            className="mr-4"
            form={form}
            onChange={updateForm}
          />
          <Radio
            name="impact_visibility"
            id="impact_visibility2"
            label="Only me"
            value="onlyme"
            form={form}
            onChange={updateForm}
          />
        </div> */}
      </div>

      <div className="mb-8 lg:mb-16">
        <div className="mb-4 lg:mb-5 flex items-center justify-between lg:justify-start">
          <div className="mr-4">
            <p className="text-sm font-bold">Baseline-Endline survey</p>
          </div>
          <p className="link">+ Add</p>
        </div>
        <SurveyInput />
      </div>

      <div>
        <div className="mb-4 lg:mb-5"><Label>Retention</Label></div>
        <div className="flex flex-wrap -mx-4">
          <div className="w-full lg:w-1/2 px-4">
            <div className="mb-8 lg:mb-12 lg:pr-10">
              <p className="text-sm text-gray-444 mb-4 lg:mb-0">Saat Program</p>
              <div className="flex justify-between items-center mb-4 lg:mb-2 pt-1">
                <p className="w-1/2 text-sm text-gray-444">Men</p>
                <InputNumber className="w-1/2"/>
              </div>
              <div className="flex justify-between items-center">
                <p className="w-1/2 text-sm text-gray-444">Women</p>
                <InputNumber className="w-1/2"/>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2 px-4">
            <div className="mb-8 lg:mb-12 lg:pr-10">
              <p className="text-sm text-gray-444 mb-4 lg:mb-0">Pasca Program</p>
              <div className="flex justify-between items-center mb-4 lg:mb-2 pt-1">
                <p className="w-1/2 text-sm text-gray-444">Men</p>
                <InputNumber className="w-1/2"/>
              </div>
              <div className="flex justify-between items-center">
                <p className="w-1/2 text-sm text-gray-444">Women</p>
                <InputNumber className="w-1/2"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-8 lg:mb-16">
        <div className="mb-4 lg:mb-5 flex items-center justify-between lg:justify-start">
          <div className="mr-4">
            <p className="text-sm font-bold">Satisfaction</p>
          </div>
          <p className="link">+ Add</p>
        </div>
        <SatisfactionInput />
      </div>

      <div className="mb-8 lg:mb-16">
        <div className="mb-4 lg:mb-5 flex items-center justify-between lg:justify-start">
          <div className="mr-4">
            <p className="text-sm font-bold">Net Promotor Score (NPS)</p>
          </div>
          <p className="link">+ Add</p>
        </div>
        <NpsInput />
      </div>

      <div className="mb-8 lg:mb-12">
        <div className="mb-4 lg:mb-5"><Label>Customer Acquisition Score (CAC)</Label></div>
        <div className="flex">
          <div className="mr-4 lg:mr-10">
            <p className="text-sm text-gray-444 mb-3">Total biaya program</p>
            <div className="flex items-center">
              <div style={{maxWidth: '107px'}} className="mr-2">
                <FormDashboardInput defaultValue="2,323,000" className="w-full text-gray-444"/>
              </div>
              <p className="text-sm text-gray-444">IDR</p>
            </div>
          </div>
          <div>
            <p className="text-sm text-gray-444 mb-3">Jumlah beneficiaries</p>
          </div>
        </div>
      </div>
    </div>
  )
}

const FormBeneficiaries = ({form, updateForm}) => {
  return (
    <div>
      <Beneficiaries form={form} updateForm={updateForm}/>
      <hr className="my-10"/>
      <Impact form={form} updateForm={updateForm}/>
    </div>
  )
}

export { FormBeneficiaries }